import React from 'react';
import { STORE_INFO } from '../../constants';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-6 md:py-8">
      <div className="container mx-auto px-4 text-center">
        <div className="text-sm md:text-base text-gray-400">
          &copy; {new Date().getFullYear()} {STORE_INFO.name}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
